export default "__VITE_ASSET__f2cf6573__"